import axios from 'axios';

const ACTIVITIES_PAGE_LIMIT = 100;

const state = {
  activities: {
    items: [],
    page: 0,
    totalCount: 0,
    loading: false,
  },
};

const getters = {
  activitiesList: () => state.activities.items,
  activitiesTotalCount: () => state.activities.totalCount,
  activitiesLoading: () => state.activities.loading,
};

export function getActivities(filters) {
  return axios.post('/insurance/lead/activity/list', {
    page: 0,
    limit: ACTIVITIES_PAGE_LIMIT,
    ...filters,
  });
}

const actions = {
  fetchActivities({commit, state}, {leadId, append = false} = {}) {
    if (!append) {
      commit('setActivitiesPage', 0);
    }
    commit('setActivitiesLoading', true);
    const page = append ? state.activities.page : 0;
    return getActivities({
      leadIds: [leadId],
      page,
      limit: ACTIVITIES_PAGE_LIMIT,
    })
      .then((response) => {
        if (append) {
          commit('appendActivities', response.data);
        } else {
          commit('setActivities', response.data);
        }
        commit('setActivitiesLoading', false);
        return response;
      })
      .catch((error) => {
        console.error('Error fetching activities:', error);
        commit('setActivitiesLoading', false);
      });
  },

  loadMoreActivities({commit, dispatch, state}, leadId) {
    if (state.activities.items.length < state.activities.totalCount && !state.activities.loading) {
      commit('incrementActivitiesPage');
      return dispatch('fetchActivities', {leadId, append: true});
    }
    return Promise.resolve();
  },

  saveActivity({dispatch}, body) {
    return axios.post('/insurance/lead/activity/save', {...body})
      .then((response) => {
        dispatch('fetchActivities', {leadId: body.leadId});
        return response;
      })
      .catch((error) => {
        console.error('Error saving activity:', error);
      });
  },

  deleteActivity({dispatch}, {activityId, leadId}) {
    return axios.post('/insurance/lead/activity/save', {
      activityId,
      activityDelete: true,
    })
      .then((response) => {
        dispatch('fetchActivities', {leadId});
        return response;
      })
      .catch((error) => {
        console.error('Error deleting activity:', error);
      });
  },
};

const mutations = {
  setActivities(state, data) {
    state.activities.items = data.items;
    state.activities.totalCount = data.totalCount;
  },
  appendActivities(state, data) {
    state.activities.items = [...state.activities.items, ...data.items];
    state.activities.totalCount = data.totalCount;
  },
  setActivitiesPage(state, page) {
    state.activities.page = page;
  },
  incrementActivitiesPage(state) {
    state.activities.page += 1;
  },
  setActivitiesLoading(state, loading) {
    state.activities.loading = loading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
